'use strict';Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(string){for(var _len=arguments.length,message=Array(1<_len?_len-1:0),_key=1;_key<_len;_key++)message[_key-1]=arguments[_key];return string.reduce(function(acc,current,index){return acc+(0<index?message[index-1]:'')+current})};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/getTextFromTemplate.js
// module id = 759
// module chunks = 0